webpackJsonp([235144415719715],{

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Anatomy = __webpack_require__(10);
	
	var _Anatomy2 = _interopRequireDefault(_Anatomy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Anatomy2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      '/assets/images/favicon.png'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'A large image to be used as the favicon.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'For new projects, this is the Lore logo, but feel free to replace it with whatever image you would like to be used instead.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Note that this file should be MUCH larger than the actual favicon. This because this file is NOT used as the favicon directly. Instead, Webpack uses it as a blueprint for the favicon, and during the build projects, will generate many (much smaller) images of various sizes that will be used by the browser.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-anatomy-assets-images-favicon-js-47400dfa44a6cd0a6dc1.js